/**
 * Scroll the nearest scrollable ancestor back to the top.
 *
 * WHY THIS EXISTS INSTEAD OF `window.scrollTo(0, 0)`: the operator shell is a
 * fixed-height grid — `AppLayout` gives the sidebar and `<main>` their own
 * independent scrollbars, so the WINDOW never scrolls and `window.scrollY` is
 * permanently 0. A `window.scrollTo(0, 0)` on route change is therefore a silent
 * no-op: it throws nothing, logs nothing, and simply leaves the reader halfway
 * down the next page. It looks like a broken link.
 *
 * Walking up from the rendered element finds whichever container is actually
 * doing the scrolling, so this keeps working if the shell's layout changes.
 */
export function scrollAncestorToTop(from: HTMLElement | null): boolean {
  let el: HTMLElement | null = from;
  while (el) {
    const style = typeof getComputedStyle === 'function' ? getComputedStyle(el) : null;
    const overflowY = style?.overflowY;
    const scrolls = overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';
    // Require BOTH a scrolling overflow and content taller than the box. An
    // `overflow:auto` container that happens to fit its content is not the
    // scroller, and stopping at it would leave the real one untouched.
    if (scrolls && el.scrollHeight > el.clientHeight) {
      el.scrollTop = 0;
      return true;
    }
    el = el.parentElement;
  }
  // Nothing found — a layout where the document itself scrolls.
  if (typeof window !== 'undefined') window.scrollTo(0, 0);
  return false;
}
